import firebase from 'firebase/app'
import 'firebase/firestore'
import { Logger } from '@/js/utils/Logger.js'

// 特別価格の管理
export default class ProductPriceManager {
    constructor() {
      this.priceData = [];
    }

    async update(){
      Logger.info("ProductPriceManager:update");
      const doc = await firebase.firestore().collection("AcryProCustomerPricing").doc( firebase.auth().currentUser.uid).get();
      if (doc.exists && doc.data().isActive) {
        this.priceData = doc.data().products;
        Logger.debug(this.priceData);
      }
    }

    getPriceData(productId){
      if( this.priceData[productId] ){
        const priceData = {};
        priceData.priceBase = this.priceData[productId].priceBase;
        priceData.price = this.priceData[productId].price;
        return priceData;
      }else{
        return null;
      }
    }
}
export { ProductPriceManager }